//import Libraries
import React from 'react';
import PropTypes from 'prop-types'

//import Components

//import Styles
import '../SignUp.css';

const signUpTextField = ({type, placeholder, onChange, value, name, autoComplete, required, errorMessage}) => {

    return (
        <div className="element">
            <input
                type={type}
                placeholder={placeholder}
                onChange={onChange}
                value={value}
                name={name}
                autoComplete={autoComplete}
                required={required}
            />
            <div>
                {
                    (errorMessage &&
                    errorMessage.length > 0) &&
                    errorMessage
                }
            </div>

        </div>
    );
}

export default signUpTextField;

signUpTextField.propTypes = {
}
signUpTextField.defaultProps = {
    type : 'text',
    placeholder : '',
    autoComplete : "on",
    required : false,
    errorMessage : ''    
}


// WEBPACK FOOTER //
// ./src/components/SignUp/Elements/SignUpTextField.js